module.exports = __webpack_public_path__ + "media/images/emblems/Attalens-coat_of_arms-af604536e066f06540d18f2c2ea28ce2.svg";